import { create } from 'zustand'

interface EncounterIdStore {
    encounterId: string
    setEncounterId: (id: string) => void
}

export const useEncounterIdStore = create<EncounterIdStore>((set) => ({
    encounterId: "",
    setEncounterId: (id) => set({ encounterId: id }),
}))